


import React from 'react'
import './FooterTwo.css'






const FooterTwo = () => {
  return (
        <>


        <div className=' w-screen overflow-hidden relative bottom-0 h-[auto] p-3 bg-yellow-400  custom-footer-container-two'>
            <div className=' flex items-center justify-center mx-auto max-w-[8000px] custom-footer-two '>

                <div className='text-black font-bold font-sans'><h3>© 2025 Next Play Nation. All rights reserved.</h3></div>


            </div>

      </div>
        
        
        
        
        
        
        
        
        
        </>
  )
}

export default FooterTwo
